export default __webpack_public_path__ + "static/holidaytaxis-logo.9f6a602a.svg";